
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-qr",
  components: {},
})
export default class IconQr extends Vue {
  @Prop() public width!: number;
  @Prop() public height!: number;
  @Prop() public color!: string;
}
